module.exports = __webpack_public_path__ + "img/ic_room_order_bottom_left_img.645ba25c.png";